// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconPlate = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M3 8V4h2v4a2 2 0 001 1.732V4h2v5.732A2 2 0 009 8V4h2v4a4 4 0 01-3 3.874V20H6v-8.126A4 4 0 013 8m17 10v2a8 8 0 110-16v2a6 6 0 000 12" />,
    <path d="M16 12a4 4 0 014-4v2a2 2 0 100 4v2a4 4 0 01-4-4" />
  );
export default SvgIconPlate;
